import { LightTheme } from "jadro-pico-app/Components/UI/Themes/LightTheme";
import { DarkTheme } from "jadro-pico-app/Components/UI/Themes/DarkTheme";

export interface AppOfflineState {
  colorThemeName: string;
}

export enum AppOfflineActionEnum {
  APP_COLOR_THEME_TOGGLE = "APP_COLOR_THEME_TOGGLE",
}

const initialState: AppOfflineState = {
  colorThemeName: LightTheme.name,
};

const appOfflineReducer = (
  state: AppOfflineState = initialState,
  action: { type: AppOfflineActionEnum; value: string },
): AppOfflineState => {
  switch (action.type) {
    case AppOfflineActionEnum.APP_COLOR_THEME_TOGGLE:
      return {
        ...state,
        colorThemeName: state.colorThemeName === LightTheme.name ? DarkTheme.name : LightTheme.name,
      };
    default:
      return state;
  }
};

export default appOfflineReducer;

export const appColorThemeToggleAction = () => ({
  type: AppOfflineActionEnum.APP_COLOR_THEME_TOGGLE,
});
